import React from "react";
import { EvtHeader } from "components/header";
import DeliverableForm from "@/modules/work/projects/deliverables/crud/form";
import { useProject } from "@/modules/work/projects/context";

const CreateDeliverable = () => {
  const { id: projectId } = useProject();
  if (!projectId) return null;
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Deliverable" />
      <div className="p-6 max-w-2xl">
        <DeliverableForm projectId={projectId} />
      </div>
    </div>
  );
};

export default CreateDeliverable;
